<template>
  <div>
    <div class="burger-wrapper animate__animated" v-show="menuVisible" v-bind:class="{ animate__fadeIn : menuVisible }">
      <div class="burger-menu animate__animated" v-bind:class="{ animate__fadeInRight : menuVisible }">
        <ul>
          <li class="flex justify-between">
            <span @click="logout"><img src="../assets/icons/logout.svg" class="mr-5">Logga ut</span>
            <img @click="showBurgerMenu" src="../assets/icons/remove.svg" class="">
          </li>
          <li class="mt-20 mb-20">
            <div class="justify-center flex">
              <img src="../assets/icons/avatar.svg" class="mr-5">
            </div>
            <div class="text-center fs-12 mt-10">
              {{ currentLoggedInUser }}
            </div>
          </li>
          <li><router-link to="/visningar">Visningar</router-link></li>
          <li><router-link to="/mina-budgivningar">Budgivningar</router-link></li>
          <li class="opaque-60">På internet</li>
          <li class="opaque-60">Sålda</li>
          <li class="opaque-60">Heta listan</li>
          <li class="opaque-60">Kö</li>
          <li class="mt-30 opaque-60">Inställningar</li>
        </ul>

      </div>
    </div>
    <img class="cy-burger" src="../assets/icons/burger.svg" @click="showBurgerMenu">
  </div>
</template>

<style>
.burger-wrapper {
  position: fixed;
  background: rgba(0,0,0,.3);
  bottom: 50px;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
}
.burger-menu {
  padding:15px;
  background: white;
  width: 80%;
}
.burger-menu ul {
  list-style: none;
  font-size: 19px;
  line-height: 1.8;
}
</style>

<script>
export default {
  name: 'BurgerMenu',
  data() {
    return {
      menuVisible: false
    }
  },
  computed: {
    currentLoggedInUser() {
      return this.$store.state.loggedInUser;
    }
  },
  methods: {
    showBurgerMenu: function () {
      this.menuVisible = !this.menuVisible;
    },
    logout() {
      this.$root.signOut();
    }
  }
}
</script>